<template>
  <el-card class="box-card">
  <div class="background">
    <div class="box1">
      <div class="boxTop">
      <div class="box2">
        <div class="item"> <div class="imgBox"><img src="../../../assets/img/userMessage/1.jpg" class="myIcon" alt="图标"></div><div class="content"><span class="title"> 用户名:</span><br>{{userMessage.userName}}</div></div>
        <div class="item"> <div class="imgBox"><img src="../../../assets/img/userMessage/3.jpg" class="myIcon" alt="图标"></div><div class="content"><span class="title">注册时间:</span><br>{{userMessage.registerDate}} </div></div>
        <div class="item"> <div class="imgBox"><img src="../../../assets/img/userMessage/5.jpg" class="myIcon" alt="图标"></div><div class="content"><span class="title">上次登录时间:</span><br>{{userMessage.lastLoginDate}}</div></div>
      </div>
      <div class="box3">
        <div class="item"><div class="imgBox"><img alt="图标" src="../../../assets/img/userMessage/2.jpg" class="myIcon"></div><div class="content"><span class="title">套餐:</span><br>{{levelName}}<span @click="$router.push('/price')" class="button1">变更套餐</span></div></div>
        <div v-if="levelDetailShow === true">
          <div class="item"><div class="imgBox"><img alt="图标" src="../../../assets/img/userMessage/3.jpg" class="myIcon"></div><div class="content"><span class="title">套餐购买时间:</span><br>{{userMessage.buyTime}} </div></div>
          <div class="item"><div class="imgBox"><img alt="图标" src="../../../assets/img/userMessage/4.jpg" class="myIcon"></div><div class="content"><span class="title">套餐过期时间:</span><br>{{userMessage.expirationTime}}</div></div>
        </div>
      </div>
      </div>
      <div class="boxBottom">
      <div class="box4">
        <span class="text-1">美钥码存储情况&nbsp;
          <span v-if="leaveNumber>=0" style="font-size:15px;color:#fe816d;">(总容量为{{totalQrNumber}}张,剩余可用{{leaveNumber}}张)</span>
          <span v-else style="font-size:15px;color:#fe816d;">(总容量为{{totalQrNumber}}张，已超出限制{{-leaveNumber}}张)</span>
        </span>
        <br>
        <div class="pro">
        <el-progress :percentage="percent2" :stroke-width="20" :text-inside="true" status="success"></el-progress>
        </div>
        <br>
        <span class="text-1">文件存储情况&nbsp;
          <span v-if="leavePercent>=0" style="font-size:15px;color:#fe816d;">(总容量为{{totalDirSizeName}},剩余可用{{leavePercent}}%)</span>
          <span v-else style="font-size:15px;color:#fe816d;">(总容量为{{totalDirSizeName}},已经超出限制{{-leavePercent}}%)</span>
        </span>
        <div class="pro">
        <el-progress :percentage="percent" :stroke-width="20" :text-inside="true" status="success"></el-progress>
        </div>
        <br>
        <el-button @click="$router.push('/price')" class="button2">增加容量</el-button>
      </div>
      <div class="box5">
        <span class="text-1">历史订单</span>
        <myTable style="margin-top:20px;" prop1="userName" prop2="date" prop3="tradeNo" prop4="commodity" prop5="totalFee" prop6="status" label1="用户名" label2="日期" label3="订单号" label4="购买套餐" label5="总金额" label6="订单状态" :dataForTable="dataForTable"></myTable>
      </div>
      </div>
    </div>
  </div>
  </el-card>
</template>

<script>
import $ from 'jquery'
import myTable from './userMessageTable.vue'
export default {
  data () {
    return {
      userMessage: '',
      levelName: '',
      totalDirSize: 0,
      totalDirSizeName: '',
      totalQrNumber: 0,
      levelDetailShow: true,
      dataForTable: []
    }
  },
  components: {
    myTable
  },
  mounted () {
    document.title = '美钥二维码 - 个人信息'
    const vm = this
    $.ajax({
      type: 'GET',
      async: false,
      url: '/v1/userMessage',
      data: {},
      dataType: 'json',
      success: function (response) {
        vm.userMessage = response.data
        if (vm.userMessage.level === '6') {
          vm.levelName = '体验版'
          vm.totalDirSize = 30 * 1024 * 1024
          vm.totalDirSizeName = '30M'
          vm.totalQrNumber = 5
        } else if (vm.userMessage.level === '1') {
          vm.levelName = '免费版'
          vm.totalDirSize = 30 * 1024 * 1024
          vm.levelDetailShow = false
          vm.totalDirSizeName = '30M'
          vm.totalQrNumber = 5
        } else if (vm.userMessage.level === '3') {
          vm.levelName = '基础版'
          vm.totalDirSize = 500 * 1024 * 1024
          vm.totalDirSizeName = '500M'
          vm.totalQrNumber = 80
        } else if (vm.userMessage.level === '4') {
          vm.totalDirSize = 2 * 1024 * 1024 * 1024
          vm.levelName = '高级版'
          vm.totalDirSame = '2G'
          vm.totalQrNumber = 350
        } else if (vm.userMessage.level === '5') {
          vm.levelName = '企业版'
          vm.totalDirSize = 4 * 1024 * 1024 * 1024
          vm.totalDirSizeName = '4G'
          vm.totalQrNumber = 800
        } else {
          vm.levelName = '无'
        }
      }
    })
    $.ajax({
      type: 'GET',
      url: '/v1/buy/trades',
      data: {},
      dataType: 'json',
      success: function (response) {
        vm.dataForTable = []
        for (let i = 0; i < response.data.length; i++) {
          let status = ''
          let commodity = ''
          let date = response.data[i].tradeNo.substring(0, 8)
          if (response.data[i].status === 1) {
            status = '已完成'
          } else {
            status = '未完成'
          }
          if (response.data[i].goodNo === 1) {
            commodity = '基础版'
          } else if (response.data[i].goodNo === 2) {
            commodity = '专业版'
          } else if (response.data[i].goodNo === 3) {
            commodity = '企业版'
          } else if (response.data[i].goodNo === 0) {
            commodity = '体验版'
          } else {
            commodity = '未知'
          }
          let temp = {userName: vm.userMessage.userName, date: date, tradeNo: response.data[i].tradeNo, commodity: commodity, totalFee: (response.data[i].totalFee / 100) + '元', status: status}
          vm.dataForTable.push(temp)
        }
      }
    })
  },
  computed: {
    percent () {
      if (this.totalDirSize === 0) {
        return 0
      }
      let per = parseFloat(((this.userMessage.dirSize / this.totalDirSize) * 100).toFixed(2))
      if (per > 100) {
        return 100
      }
      return per
    },
    percent2 () {
      if (this.totalQrNumber === 0) {
        return 0
      }
      let per = parseFloat(((this.userMessage.qrNumber / this.totalQrNumber) * 100).toFixed(2))
      if (per > 100) {
        return 100
      }
      return per
    },
    leavePercent () {
      return 100 - this.percent
    },
    leaveNumber () {
      return this.totalQrNumber - this.userMessage.qrNumber
    }
  }
}
</script>

<style scoped>
.background {
  /* background-image: url('../../../assets/img/images/38.png'); */
  background-size: cover;
  padding-top: 10px;
  padding-bottom: 50px;
  text-align: center;
  color: black;
  float: left;
}
.box1 {
  margin-top: 20px;
  /* margin-left: 10%; */
  width: 100%;
  font-size: 20px;
}
.boxTop {
  float: left;
  width: 100%;
  font-size: 16px;
opacity: 0.85;
text-align: left;
letter-spacing: 2px;
padding: 0px 0px 50px 0px;
border-bottom: 1px solid #dddddd;
}
.box2 {
  float: left;
  /* width: 20%; */
  text-align: left;
  height: 100%;
  padding-left: 100px;
}
.box3 {
  float: left;
  /* width: 60%; */
  min-width: 200px;
  padding-left: 0px;
  /* border: 1px solid rgb(166,166,166); */
  /* box-shadow: 10px 10px 30px rgb(166,166,166); */
}
.boxBottom {
  background-color: white;
  padding-bottom: 50px;
  color: black;
  float: left;
  width: 100%;
}
.box4 {
  margin-top: 50px;
  text-align: left;
  padding-left: 6%;
  /* border: 1px solid rgb(166,166,166); */
  /* box-shadow: 10px 10px 80px rgb(166,166,166); */
}
.box5 {
  margin-top: 50px;
    text-align: left;
  padding-left: 6%;
  /* border: 1px solid rgb(166,166,166); */
  /* box-shadow: 10px 10px 80px rgb(166,166,166); */
}
.box3 .button1 {
  margin-top: 20px;
}
.button1 {
    width:80px;
  height: 35px;
  border: 1px solid #38dba4;
  background: #38dba4;
  color: white;
  font-size: 15px;
  border-radius: 30px;
  letter-spacing: 2px;
  font-weight: 100;
  /* padding: 5px; */
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 10px;
  padding-right: 10px;
  margin-left: 10px;
}
.button1:hover {
  background: #11c181;
  border: 1px solid #38dba4;
  color: white;
  cursor: pointer;
}
.button2 {
    width:300px;
  height: 50px;
  border: 1px solid #fe816d;
  background: #fe816d;
  color: white;
  font-size: 20px;
  border-radius: 30px;
  padding-left: 20px;
  letter-spacing: 8px;
  font-weight: 100;
}
.button2:hover {
  background: #f4584d;
  border: 1px solid #f4584d;
  color: white;
}
.imgBox {
  width: 20%;
  /* float: left; */
}
.myIcon {
  height: auto;
  width: 45px;
  margin-top: 5px;
  float: left;
}
.content {
  float: left;
  width: 80%;
  padding-top: 5px;
  margin-left: 5px;
}
.pro {
  margin-top: 20px;
  /* border: 1px solid #fe816d; */
  width: 80%;
  text-align: center;
}
.text-1 {
  font-weight: 700;
}
.item {
  float: left;
  margin-top: 20px;
  width: 100%;
  /* border: 1px solid red; */
}
.title {
  font-weight: 700;
}
.box-card {
  margin: 10px 15px;
}
</style>
